<template>
    <div class="modal" id="recurring_shift_confirm_modal" tabindex="-1" aria-labelledby="recurring_shift_confirm_modal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title mb-1">
                        <h4>{{ $trans.get('__JSON__.Confirm recurring shifts') }}</h4>
                        <span class="d-block text-sm text-muted">
                            {{ $trans.get('__JSON__.You are about to create the following shifts') }}
                        </span>
                    </div>
                </div>
                <div class="modal-body" v-if="Object.values(confirmationData).length > 0">
                    <h6>{{ $trans.get('__JSON__.Overview') }}</h6>
                    <table class="table table-sm table-borderless">
                        <thead>
                        <tr>
                            <th>{{ $trans.get('__JSON__.Job') }}</th>
                            <th>{{ $trans.get('__JSON__.Slots') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{{ confirmationData.job }}</td>
                            <td>{{ confirmationData.slots }}</td>
                        </tr>
                        </tbody>
                        <thead>
                        <tr>
                            <th>{{ $trans.get('__JSON__.For period') }}</th>
                            <th>{{ $trans.get('__JSON__.Total shifts') }}</th>
                            <th>{{ $trans.get('__JSON__.Total hours') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                <span>{{ formatDate(confirmationData.period_start, DATE_YMD) }}</span>
                                <span class="d-block">{{ $trans.get('__JSON__.until') }} {{ formatDate(confirmationData.period_end, DATE_YMD) }}</span>
                            </td>
                            <td>{{ confirmationData.amount_of_shifts }}</td>
                            <td>{{ confirmationData.amount_of_hours }}</td>
                        </tr>
                        </tbody>
                    </table>

                    <div class="mt-5" v-if="confirmationData.differences.length > 0">
                        <h6>{{ $trans.get('__JSON__.Shift differences') }}</h6>
                        <table class="table table-sm table-borderless">
                            <thead>
                            <tr>
                                <th>{{ $trans.get('__JSON__.Date') }}</th>
                                <th>{{ $trans.get('__JSON__.Slots') }}</th>
                                <th>{{ $trans.get('__JSON__.Addition') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="difference in confirmationData.differences">
                                <td>{{ formatDate(difference.date, DATE_YMD) }}</td>
                                <td v-if="difference.slots > 0">{{ difference.slots }}</td>
                                <td v-if="difference.slots > 0">{{ difference.notes }}</td>
                                <td class="text-danger" colspan="3" v-if="difference.slots === 0">
                                    {{ $trans.get('__JSON__.We will not include this date') }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-sm btn-outline-warning" @click="cancel">
                        {{ $trans.get('__JSON__.Cancel') }}
                    </button>
                    <button class="btn btn-sm btn-success" @click="confirm">
                        {{ $trans.get('__JSON__.Agree') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DateHelpers from '../mixins/DateHelpers'
import ModalHelper from '../mixins/ModalHelper'

export default {
    name: 'RecurringShiftConfirmationModal',
    mixins: [DateHelpers, ModalHelper],
    props: {
        confirmationData: {
            type: Object,
            required: true,
        },
    },
    methods: {
        async cancel() {
            this.$parent.$data.recurring.confirmed = false
            await this.closeModal('recurring_shift_confirm_modal')
        },
        async confirm() {
            this.$parent.$data.recurring.confirmed = true
            await this.closeModal('recurring_shift_confirm_modal')
        },
    },
}
</script>
